import { Component, OnInit } from '@angular/core';
import { OffCanvasChildComponent } from 'src/app/model/off-canvas-child-component';
import { OffCanvasService } from 'src/app/services';

@Component({
    templateUrl: './my-wins-details.component.html',
    styleUrls: ['./my-wins-details.component.scss']
})
export class MyWinsDetailsComponent extends OffCanvasChildComponent implements OnInit
{
    public constructor(offCanvasService: OffCanvasService)
    {
        super(offCanvasService);
    }

    public ngOnInit(): void
    {
    }
}

